import { __rest } from 'tslib';
import React from 'react';
import { styled } from '../../../libs/styled.es.js';
import { iconMap } from './icons.es.js';
import { space } from 'styled-system';

const StyledSvgIcon = styled.span(space, ({ imageUrl, color, themeColor, theme, size }) => `
    mask: url("${imageUrl}");
    display: inline-block;
    width: ${size || 50}px;
    height: ${size || 50}px;
    background-color: var(--button-icon-color, 
      ${(themeColor && (theme.brand[themeColor] || theme.colors[themeColor])) ||
    color ||
    theme.colors.gray600});
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  `);
const SvgIcon = (_a) => {
    var { name, onClick } = _a, props = __rest(_a, ["name", "onClick"]);
    const imageUrl = iconMap[name];
    if (!imageUrl) {
        return null;
    }
    return React.createElement(StyledSvgIcon, Object.assign({ onClick: onClick, imageUrl: imageUrl }, props));
};

export { SvgIcon };
